import { render, staticRenderFns } from "./NotasFiscaisForm.vue?vue&type=template&id=166792db&scoped=true&"
import script from "./NotasFiscaisForm.vue?vue&type=script&lang=js&"
export * from "./NotasFiscaisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166792db",
  null
  
)

export default component.exports